import { requestDialog } from './requestDialog';
import type { StorageProfileDialogRequest } from './storageProfileDialogRequest';

export function showStorageProfileDialog(req: StorageProfileDialogRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/StorageProfileDialog.vue'));
}
